import React from 'react';
import { Check, X } from 'lucide-react';
export function ComparisonTable() {
  const rows = [{
    feature: 'Conseguir proveedor',
    no: 'Semanas buscando en Google',
    yes: 'Directorio listo desde el Día 1'
  }, {
    feature: 'Calcular el precio',
    no: 'A ojo, sin fórmula',
    yes: 'Fórmula exacta con margen real'
  }, {
    feature: 'Responder preguntas del cliente',
    no: 'Sin saber qué contestar',
    yes: 'Guiones listos para usar'
  }, {
    feature: 'Primera venta',
    no: 'Meses esperando el momento',
    yes: 'Plan de 7 días con tareas concretas'
  }, {
    feature: 'Control del negocio',
    no: 'Sin saber si ganás o perdés',
    yes: '3 planillas y 10 min/día'
  }, {
    feature: 'Ferias y eventos',
    no: 'No sabés dónde ni cómo',
    yes: '39 ferias mapeadas en todo AR'
  }, {
    feature: 'Clientes que vuelven',
    no: 'Siempre buscando clientes nuevos',
    yes: 'Sistema de fidelización (Megapack)'
  }, {
    feature: 'Presencia en redes',
    no: 'Posts sin estrategia ni resultados',
    yes: 'Calendario + fórmula de contenido (Megapack)'
  }];
  return <section className="py-12 sm:py-20" data-id="element-52">
      <div className="mx-auto max-w-[800px] px-6" data-id="element-53">
        <div className="mb-3 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-54">
          La realidad
        </div>
        <h2 className="mb-4 font-serif text-[clamp(24px,4vw,38px)] font-bold leading-[1.2] text-white" data-id="element-55">
          ¿Cuánto cuesta NO tenerlo?
        </h2>
        <p className="mb-8 sm:mb-12 max-w-[560px] text-[15px] text-text" data-id="element-56">
          La diferencia entre seguir improvisando y tener un sistema.
        </p>

        <div className="overflow-x-auto rounded-xl border border-border" data-id="element-57">
          <table className="w-full border-collapse" data-id="element-58">
            <thead data-id="element-59">
              <tr className="bg-card" data-id="element-60">
                <th className="p-4 text-left text-[13px] font-semibold text-white sm:px-5" data-id="element-61">
                  Situación
                </th>
                <th className="p-4 text-center text-[13px] font-semibold text-white sm:px-5" data-id="element-62">
                  Sin el sistema
                </th>
                <th className="p-4 text-center text-[13px] font-semibold text-white sm:px-5" data-id="element-63">
                  Con el sistema
                </th>
              </tr>
            </thead>
            <tbody data-id="element-64">
              {rows.map((row, i) => <tr key={i} className="border-t border-border even:bg-gold/5" data-id="element-65">
                  <td className="p-4 text-left text-[13px] text-muted sm:px-5" data-id="element-66">
                    {row.feature}
                  </td>
                  <td className="p-4 text-center text-[13px] text-text sm:px-5" data-id="element-67">
                    <div className="flex flex-col items-center gap-1 sm:flex-row sm:justify-center" data-id="element-68">
                      <X className="h-4 w-4 text-[#333]" data-id="element-69" />
                      <span data-id="element-70">{row.no}</span>
                    </div>
                  </td>
                  <td className="p-4 text-center text-[13px] text-text sm:px-5" data-id="element-71">
                    <div className="flex flex-col items-center gap-1 sm:flex-row sm:justify-center" data-id="element-72">
                      <Check className="h-4 w-4 text-gold" data-id="element-73" />
                      <span data-id="element-74">{row.yes}</span>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}